export function Slash({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 2.3125C21.9983 2.3125 27.6875 8.00171 27.6875 15C27.6875 21.9983 21.9983 27.6875 15 27.6875C8.00171 27.6875 2.3125 21.9983 2.3125 15C2.3125 8.00171 8.00171 2.3125 15 2.3125ZM15 2.6875C8.21079 2.6875 2.6875 8.21079 2.6875 15C2.6875 21.7892 8.21079 27.3125 15 27.3125C21.7892 27.3125 27.3125 21.7892 27.3125 15C27.3125 8.21079 21.7892 2.6875 15 2.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M23.625 6.06543C23.6785 6.06548 23.7246 6.08511 23.7568 6.11719C23.7891 6.14948 23.8096 6.19622 23.8096 6.25C23.8095 6.30369 23.7891 6.34958 23.7568 6.38184L6.25684 23.8818C6.23481 23.9039 6.21362 23.917 6.19434 23.9248C6.17448 23.9327 6.15129 23.9375 6.125 23.9375C6.09848 23.9375 6.07467 23.9329 6.05469 23.9248C6.03544 23.917 6.01415 23.9038 5.99219 23.8818C5.96011 23.8496 5.94048 23.8035 5.94043 23.75C5.94043 23.6962 5.9599 23.6495 5.99219 23.6172L23.4922 6.11719C23.5245 6.0849 23.5712 6.06543 23.625 6.06543Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
